import { axios } from '../config/axios';
import security from './security'

const Birthdays = {};

export const BIRTHDAYS_PAGE_SIZE = 30;

Birthdays.listAll = (month, page = 1, nome = '', display = 'ALL') => {
  return security.validation(axios.get(`/birthdays?month=${month}&page=${page}&page_size=${BIRTHDAYS_PAGE_SIZE}&nome=${encodeURIComponent(nome)}&display=${display}`));
};

Birthdays.listMonths = () => {
  return security.validation(axios.get('/birthdays/months'));
};

Birthdays.findConfig = () => {
  return security.validation(axios.get('/birthdays/greetings/config'));
};

Birthdays.updateConfig = (body) => {
  return security.validation(axios.patch('/birthdays/greetings/config', body));
};

Birthdays.updateImage = (formData) => {
  return security.validation(axios.patch('/birthdays/greetings/config/image', formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }));
};

Birthdays.deleteImage = () => {
  return security.validation(axios.delete('/birthdays/greetings/config/image'));
};

Birthdays.sendTest = (email) => {
  return security.validation(axios.post('/birthdays/greetings/test', { email }));
};

Birthdays.dispatch = () => {
  return security.validation(axios.post('/birthdays/greetings/dispatch'));
};

export default Birthdays;
